export default {"src":"/_next/static/media/dcn.309fba60.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};